/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1BadgeIcon20Solid = forwardRef('People1BadgeIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 10.335A4.168 4.168 0 1 0 10 2a4.168 4.168 0 0 0 0 8.335Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 12c-2.405 0-7.054.35-7.875 5.364-.146.894.61 1.636 1.516 1.636h12.718c.906 0 1.662-.742 1.516-1.636C17.055 12.35 12.405 12 10 12Zm0 4a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2h-3a1 1 0 0 1-1-1Z" })));
});
